<template>
  <div>
    <div class="btn-group">
      <label class="inline" v-if="!edit_mode">
        <input type="radio" :disabled="edit_mode" :value="true" v-model="actionSelect" @click="onClickNew" checked="checked" />
        {{ i18nJS.forms.guest_activity_plans['new_plan'] }}
      </label>
      <label class="inline" v-if="edit_mode && !grid_mode">
        <input type="radio" :disabled="edit_mode" :value="true" v-model="actionSelect" checked="checked" />
        {{ i18nJS.forms.guest_activity_plans['edit_plan'] }}
      </label>
      <label class="inline" v-if="edit_mode && grid_mode">
        <input type="radio" :disabled="edit_mode" :value="grid_mode" v-model="actionSelect" checked="checked" />
        {{ i18nJS.forms.guest_activity_plans['edit_connect_plan'] }}
      </label>
      <label class="inline" v-if="edit_mode && grid_mode">
        <input type="radio" :disabled="edit_mode" :value="!grid_mode" v-model="actionSelect" />
        {{ i18nJS.forms.guest_activity_plans['edit_plan'] }}
      </label>
      <label class="inline" v-if="!grid_mode">
        <input type="radio" :disabled="edit_mode" :value="false" v-model="actionSelect" @click="onClickConnect" />
        {{ i18nJS.forms.guest_activity_plans['connect_plan'] }}
      </label>
    </div>
    <template v-if="!plan_action && !grid_mode">
      <h3 class="title">
        {{ i18nJS.forms.guest_activity_plans['connect_plan'] }}
      </h3>
    </template>
    <template v-if="plan_action && grid_mode">
      <h3 class="title">
        {{ i18nJS.forms.guest_activity_plans['edit_connect_plan'] }}
      </h3>
      <p class="text-info">
        {{ i18nJS.forms.guest_activity_plans['edit_connect_plan_info'] }}
      </p>
    </template>
    <template v-else-if="plan_action && !edit_mode">
      <h3 class="title">
        {{ i18nJS.forms.guest_activity_plans['new_plan'] }}
      </h3>
    </template>
    <template v-else-if="plan_action && edit_mode">
      <h3 class="title">
        {{ i18nJS.forms.guest_activity_plans['edit_plan'] }}
      </h3>
    </template>
  </div>
</template>

<script>
export default {
  name: 'chosePlanAction',
  props: {
    plan_action: { type: Boolean, default: false },
    grid_mode: { type: Boolean, default: false },
    edit_mode: { type: Boolean, default: false },
  },
  data() {
    return {
      actionSelect: true,
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {
    onClickNew() {
      this.$emit('newMode', true);
    },
    onClickConnect() {
      this.$emit('connectMode', false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
